/**
* @author Andrés Camilo Ferreira Rodríguez
* @Copyright (c) Infotrack. All rights reserved.
*/
export default {
'sidebar.smartstock': 'Smart  Stock',
'sidebar.tiposDivisiones': 'Tipos  Divisiones',
'tiposDivisiones.agregarTipos Divisiones': 'Create Tipos  Divisiones',
'tiposDivisiones.modificarTipos Divisiones': 'Edit Tipos  Divisiones',
'tiposDivisiones.eliminarTipos Divisiones': 'Delete Tipos  Divisiones',
'tiposDivisiones.tipoDivisionId': 'Tipo   Division   Id ',
'tiposDivisiones.empresaId': ' Empresa   Id ',
'tiposDivisiones.tipoDivisionDescripcion': ' Tipo   Division   Descripcion',
'tiposDivisiones.tipos Divisiones': 'Tipos  Divisiones',
'tiposDivisiones.verTipos Divisiones': 'View Tipos  Divisiones',
};

